import React from 'react';
import Icon from '../../../components/AppIcon';

const EncryptionManagement = () => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="Lock" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground">
              Health Data Encryption
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">
              Automatic AES-256 encryption for all health data
            </p>
          </div>
        </div>
        <div className="px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
          Always Active
        </div>
      </div>

      <div className="space-y-4">
        <div className="bg-success/5 border border-success/20 rounded-lg p-4">
          <div className="flex items-start gap-2">
            <Icon name="ShieldCheck" size={18} className="text-success flex-shrink-0 mt-0.5" />
            <div className="text-sm text-success">
              <p className="font-medium mb-1">Mandatory Encryption Active</p>
              <p className="text-xs">All health data (symptom entries, check-ins, medications, personal health information) is automatically encrypted before storage using AES-256 encryption. Your data is protected at rest with privacy-focused security.</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 text-center">
          <div className="bg-muted/50 rounded-lg p-3">
            <div className="text-2xl font-bold text-foreground">AES-256</div>
            <div className="text-xs text-muted-foreground mt-1">Algorithm</div>
          </div>
          <div className="bg-muted/50 rounded-lg p-3">
            <div className="text-2xl font-bold text-foreground">PBKDF2</div>
            <div className="text-xs text-muted-foreground mt-1">Key Derivation</div>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={18} className="text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-1">How It Works</p>
              <ul className="space-y-1 text-xs">
                <li>• Encryption happens automatically on your device before data is stored</li>
                <li>• Each device has a unique encryption key stored securely in your browser</li>
                <li>• No passwords to remember - encryption is seamless and transparent</li>
                <li>• Data remains encrypted in our database at all times</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-sm font-medium text-foreground">Privacy Features:</p>
          <ul className="space-y-2 text-xs text-muted-foreground">
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="text-success flex-shrink-0 mt-0.5" />
              <span>Military-grade AES-256 encryption for all health data</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="text-success flex-shrink-0 mt-0.5" />
              <span>Privacy-focused design with encrypted data storage</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="text-success flex-shrink-0 mt-0.5" />
              <span>Automatic encryption - no user action required</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={14} className="text-success flex-shrink-0 mt-0.5" />
              <span>Secure key derivation using PBKDF2 with 10,000 iterations</span>
            </li>
          </ul>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
          <div className="flex items-start gap-2">
            <Icon name="AlertTriangle" size={18} className="text-amber-600 flex-shrink-0 mt-0.5" />
            <div className="text-xs text-amber-800">
              <p className="font-medium mb-1">Important Note:</p>
              <p>Encryption keys are stored locally on your device. If you clear your browser data or switch devices, you may not be able to decrypt previously encrypted data. We recommend regular data exports for backup purposes.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EncryptionManagement;